// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SE-z","hovered":"TE-z","hoverImage":"UE-z","mainImage":"VE-z","imageNoBackground":"WE-z","fullSizeImage":"XE-z"};